import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { StepProps } from '../TimsurveyWizard'
import { timsurveyApi } from '../../../services/api'
import { TimsurveyNmu } from '../../../types/timsurvey'

const CODICI_ORE_ECONOMIA = new Set(['937381', '937382', '937384', '937385', '937386'])
const NMU_RACK_LARGE = '992867'

export default function StepVociListino({ form, setForm, onNext, onBack }: StepProps) {
  const { data } = useQuery({
    queryKey: ['timsurvey-nmu'],
    queryFn: () => timsurveyApi.catalogo.nmu().then(r => r.data as TimsurveyNmu[]),
    staleTime: Infinity,
  })
  const nmu = data ?? []
  const [gruppoAperto, setGruppoAperto] = useState<string | null>(null)

  const gruppi = Array.from(new Set(nmu.map(n => n.gruppo)))

  const quantitaDi = (code: string) => form.voci_listino.find(v => v.nmu_code === code)?.quantita ?? 0

  const setQuantita = (code: string, quantita: number) => {
    setForm(f => {
      if (quantita <= 0) {
        return { ...f, voci_listino: f.voci_listino.filter(v => v.nmu_code !== code) }
      }
      const esiste = f.voci_listino.some(v => v.nmu_code === code)
      return {
        ...f,
        voci_listino: esiste
          ? f.voci_listino.map(v => v.nmu_code === code ? { ...v, quantita } : v)
          : [...f.voci_listino, { nmu_code: code, quantita }],
      }
    })
  }

  const haUpsSenzaRackLarge =
    form.voci_listino.some(v => nmu.find(n => n.nmu_code === v.nmu_code)?.gruppo === 'FORNITURA_UPS') &&
    !form.voci_listino.some(v => v.nmu_code === NMU_RACK_LARGE)

  return (
    <div className="card p-4 space-y-3">
      {haUpsSenzaRackLarge && (
        <div className="text-sm bg-yellow-50 border border-yellow-300 text-yellow-800 rounded-md p-3">
          Attenzione: UPS selezionato senza rack Large ({NMU_RACK_LARGE}) in questa pratica.
        </div>
      )}

      {gruppi.map(gruppo => (
        <div key={gruppo} className="border border-slate-100 rounded-md">
          <button
            className="w-full text-left p-3 font-medium text-sm text-slate-700"
            onClick={() => setGruppoAperto(g => g === gruppo ? null : gruppo)}
          >
            {gruppo.replace(/_/g, ' ')}
          </button>
          {gruppoAperto === gruppo && (
            <div className="p-3 pt-0 space-y-2">
              {nmu.filter(n => n.gruppo === gruppo).map(n => {
                const disabilitata = form.situazione === 'STANDARD' && CODICI_ORE_ECONOMIA.has(n.nmu_code)
                return (
                  <div key={n.nmu_code} className={`flex items-center justify-between gap-2 text-sm ${disabilitata ? 'opacity-40' : ''}`}>
                    <span title={disabilitata ? 'Disponibile solo con situazione Fuori Standard' : undefined}>
                      {n.descrizione} <span className="text-slate-400">({n.nmu_code})</span>
                    </span>
                    <div className="flex items-center gap-2">
                      <button
                        className="btn-secondary px-2"
                        disabled={disabilitata}
                        onClick={() => setQuantita(n.nmu_code, Math.max(0, quantitaDi(n.nmu_code) - 1))}
                      >-</button>
                      <span className="w-6 text-center">{quantitaDi(n.nmu_code)}</span>
                      <button
                        className="btn-secondary px-2"
                        disabled={disabilitata}
                        onClick={() => setQuantita(n.nmu_code, quantitaDi(n.nmu_code) + 1)}
                      >+</button>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      ))}

      <div className="flex gap-2">
        <button className="btn-secondary" onClick={onBack}>Indietro</button>
        <button className="btn-primary flex-1" onClick={onNext}>Avanti</button>
      </div>
    </div>
  )
}
